export default {
  justNow: 'just now',
  minutesAgo: '{n} minutes ago',
  hoursAgo: '{n} hours ago',
  daysAgo: '{n} days ago',
  monthsAgo: '{n} months ago',
  yearsAgo: '{n} years ago',
}
